export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";